import { REGEX } from './../../../app.validators';
import { Partner } from './../partner.model';
import { Component, Injector } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/components/base-form-component/base-form-component';
import { Validators } from '@angular/forms';
import { CityService } from 'src/app/shared/services/cities.service';
import { City } from 'src/app/shared/models/city.model';
import { PartnersService } from '../partiners.service';

@Component({
    selector: 'ng-partiner-form',
    templateUrl: 'partiner-form.component.html',
    styleUrls:['partiner-form.component.css']
})

export class PartinerFormComponent extends BaseFormComponent<Partner> {
    
    public cities: Array<City>;
    public isThereCitiesInLocalStorage: boolean;

    constructor(public injector:Injector,public partnerServ:PartnersService,private cityServ:CityService) { 
        super(injector,'partner','/admin/partners',Partner.fromJsonToObject,partnerServ);
    }

    protected initChildProprieties(): void {
        this.cities=new Array<City>();
        this.isThereCitiesInLocalStorage=false;
    }

    protected initChildMethods(): void {

        !!localStorage.getItem('cities')?
        this.isThereCitiesInLocalStorage=true:
        this.isThereCitiesInLocalStorage=false

        if(this.isThereCitiesInLocalStorage){
            this.cities=this.cityServ.buildArrayOfObjects(JSON.parse(localStorage.getItem("cities")));
            return;
        }

        this.formSubscription.add(this.cityServ.getAll().subscribe(cities => {
            this.cities=cities
            this.saveInLocalStorage(cities)
        }))
    }
    
    private saveInLocalStorage(cities:Array<City>) {
        localStorage.setItem('cities',JSON.stringify(cities))
    }

    protected buildForm(): void {

        this.objectForm=this.formBuilder.group({

                name:this.formBuilder.control(null,[Validators.required]),

                partner_description:this.formBuilder.control(null,[Validators.required]),

                phone:this.formBuilder.control(null,[
                    Validators.required,
                    Validators.minLength(9),
                    Validators.maxLength(14),
                    Validators.pattern(REGEX.numberPattern)
                ]),

                address:this.formBuilder.control(null,[Validators.required]),

                nuit:this.formBuilder.control(null,[
                    Validators.required,
                    Validators.minLength(9),
                    Validators.maxLength(9),
                    Validators.pattern(REGEX.numberPatternNoComma)
                ]),

                responsible_name:this.formBuilder.control(null),

                responsible_phone:this.formBuilder.control(null,[
                    Validators.minLength(9),
                    Validators.maxLength(14),
                    Validators.pattern(REGEX.numberPattern)
                ]),

                responsible_email:this.formBuilder.control(null,[Validators.pattern(REGEX.email)]),

                cities_id:this.formBuilder.control(null,[Validators.required]),

                id:this.formBuilder.control(null),
            });
    }
}